import angular from 'angular';
import HoursBuilderRowModule from './hours-builder-row/hours-builder-row';

const ComponentsModule = angular.module('control-room.commons.form.components.hours-builder.components', [
    HoursBuilderRowModule.name,
]);

export default ComponentsModule;
